"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const fp_1 = require("lodash/fp");
const react_virtualized_1 = require("react-virtualized");
const DefaultNotification_1 = tslib_1.__importDefault(require("../Notification/DefaultNotification"));
const AutoSizer = react_virtualized_1.AutoSizer;
const List = react_virtualized_1.List;
// eslint-disable-next-line max-lines-per-function
const NotificationsList = ({ notifications, overscanRowCount = 10, noRowsRenderer = () => (0, jsx_runtime_1.jsx)(NoRowsElement, { children: "No notifications" }), rowHeight = 162, height, width, onOperation = fp_1.noop, virtualizedListUpdateBit }) => {
    const getRowComponent = react_1.default.useCallback((row) => ((0, jsx_runtime_1.jsx)(NotificationContainer, Object.assign({ style: row.style }, { children: (0, jsx_runtime_1.jsx)(DefaultNotification_1.default, Object.assign({}, notifications[row.index], { onOperation: onOperation })) }), row.key)), [notifications, onOperation]);
    return ((0, jsx_runtime_1.jsx)(AutoSizer, { children: (size) => ((0, jsx_runtime_1.jsx)(List, { height: height || size.height, rowCount: notifications.length, noRowsRenderer: noRowsRenderer, overscanRowCount: overscanRowCount, rowRenderer: (row) => getRowComponent(row), rowHeight: rowHeight, width: width || size.width, updateTriggerProp: virtualizedListUpdateBit })) }));
};
exports.default = NotificationsList;
const NotificationContainer = styled_components_1.default.div `
    padding: 8px 24px;
    box-sizing: border-box;
`;
const NoRowsElement = styled_components_1.default.div `
    font-family: ${({ theme }) => theme.fonts.robotoMedium};
    font-size: 20px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.NTDarkGrey[500]};
`;
